<template>

</template>

<script>
    export default {
        name: "Middle",
        mounted(){
            this.$router.push('index/home');
        }
    }
</script>
